export default __webpack_public_path__ + "static/media/017-kite.0370f9d6.svg";